// import React, { PropTypes } from 'react';
//
// const App = (props) => {
//     return (
//         <div className="App">
//             {props.children}
//         </div>
//     );
// };
//
// App.propTypes = {
//     children: PropTypes.element
// };
//
// export default App;

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/actionCreators';

class App extends React.Component {
    render() {
        return (
            <div className="App">
                {/*{React.cloneElement(this.props.children, this.props)}*/}
                {this.props.children}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        users: state.users,
        currentUser: state.currentUser,
        requests: state.requests,
        permissions: state.permissions
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/components/App/App.js
 **/